import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finish } from './state/finish_actions_creator';
import { Store } from '@ngrx/store';
import { FinishState } from './state/finish_state';

@Component({
  selector: 'yi-finish',
  template: require('./finish.component.html'),
  styles: [require('./finish.component.scss')]
})
export class FinishComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private store: Store<FinishState>) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let completeParams = {
        originalParams: {}
      };
      Object.keys(params).forEach(function (key) {
        completeParams['originalParams'][key] = decodeURI(params[key]);
      });
      this.store.dispatch(finish({payload: completeParams}));
    });
  }

}
